import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../components/Notification';
import HttpStatus from '../../../../../enums/httpStatus';
import { orderStatusApi } from '../../../../../services/requests';
import * as TP from '../../../../../types/apiResponseTypes';

type Props = {
  closeModal: () => void;
  reqGetAllOrderStatuses: () => void;
  orderStatusSelected: TP.OrderStatus;
};

const EditOrderStatus = ({ closeModal, reqGetAllOrderStatuses, orderStatusSelected }: Props) => {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [description, setDescription] = useState('');
  const [alt1, setAlt1] = useState('');
  const [alt2, setAlt2] = useState('');

  useEffect(() => {
    setDescription(orderStatusSelected.description);
    setAlt1(orderStatusSelected.alt_1 || '');
    setAlt2(orderStatusSelected.alt_2 || '');
  }, [orderStatusSelected]);

  const reqUpdateOrderStatus = async () => {
    setIsLoading(true);

    const source = orderStatusApi.axios.CancelToken.source();

    try {
      const res = await orderStatusApi.update(
        {
          description,
          alt_1: alt1 || null,
          alt_2: alt2 || null,
        },
        orderStatusSelected.id,
      );

      if (res.status === HttpStatus.OK) {
        setIsLoading(false);
        frontendNotification({
          message: t('successfullyUpdated'),
          type: 'success',
        });

        closeModal();
        reqGetAllOrderStatuses();
      } else {
        throw res;
      }

      setIsLoading(false);
    } catch (err) {
      if (!orderStatusApi.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
      setIsLoading(false);
    }

    return () => {
      source.cancel('Component got unmounted');
    };
  };

  return (
    <Modal
      title={t('editOrderStatus')}
      showModal
      closeModal={closeModal}
      action={() => reqUpdateOrderStatus()}
      isLoading={isLoading}
    >
      <div className="form">
        <div className="form-row">
          <div className="form-row-item">
            <label htmlFor="orderStatusKeyEdit">{t('key') as string}</label>
            <input
              id="orderStatusKeyEdit"
              type="text"
              value={orderStatusSelected.key}
              disabled
            />
          </div>
          <div className="form-row-item">
            <label htmlFor="orderStatusDescriptionEdit">{t('description') as string}</label>
            <input
              id="orderStatusDescriptionEdit"
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              disabled={isLoading}
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <label htmlFor="orderStatusAlt1Edit">{t('alt1') as string}</label>
            <input
              id="orderStatusAlt1Edit"
              type="text"
              value={alt1}
              onChange={(e) => setAlt1(e.target.value)}
              disabled={isLoading}
            />
          </div>
          <div className="form-row-item">
            <label htmlFor="orderStatusAlt2Edit">{t('alt2') as string}</label>
            <input
              id="orderStatusAlt2Edit"
              type="text"
              value={alt2}
              onChange={(e) => setAlt2(e.target.value)}
              disabled={isLoading}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditOrderStatus;
